var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 9.66699V12.0668H1.50022V9.66699H0V12.0668C0.00118699 12.4908 0.159627 12.8971 0.440717 13.1969C0.721807 13.4967 1.10271 13.6657 1.50022 13.667H10.4998C10.8973 13.6657 11.2782 13.4967 11.5593 13.1969C11.8404 12.8971 11.9988 12.4908 12 12.0668V9.66699H10.4998Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 5.833L9.15801 4.658L7.00001 6.808L7.00001 -2.9138e-07L5.33301 -4.37114e-07L5.33301 6.808L3.17501 4.658L2.00001 5.833L6.16601 10L10.333 5.833Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a6ff3b4a44c7e5f14d25f420523da439.svg";
export { ForwardRef as ReactComponent };